import { render, staticRenderFns } from "./AdminReportesComponent.vue?vue&type=template&id=011474fa&"
import script from "./AdminReportesComponent.vue?vue&type=script&lang=js&"
export * from "./AdminReportesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports